import React, { useState } from 'react'
import Select from "react-select"
import moment from "moment"
import { Cascader, Dropdown, Menu, DatePicker } from 'antd'

import { AiOutlineDown } from 'react-icons/ai'

import Receive from '../../components/reusable/receive'
import Patient from '../../components/reusable/patient'

import { usePet, normalize, stringifyDate, useToggle, server, useListData } from '../../modules'
import ByPaymentMethod from '../../components/modals/byPaymentMethod'
import EndofDay from '../../components/modals/endOfDay'

const { RangePicker } = DatePicker

const ByStaff = () => {
    return (
        <>
            <div className="sm:flex sm:justify-between sm:items-between mb-8">
                <div className="grid grid-flow-col sm:auto-cols-max justify-start sm:justify-end items-center gap-2">
                </div>
                <div className="grid grid-flow-col sm:auto-cols-max justify-start sm:justify-end items-center gap-2">
                    <RangePicker
                        showTime/>
                </div>
            </div>
            <div className="col-span-full xl:col-span-8 bg-white shadow-lg rounded-sm border border-gray-200">
                <div className="flex py-10 font-semibold text-md justify-center items-center">
                    <h2>Please select a date range</h2>
                </div>
            </div>
        </>
    )
}

export default ByStaff